import React from 'react';
import { Collapse } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PasswordField } from '../../app/form/textfield/password-field';
import { getPasswordRequirements } from '../../../utils/password-requirements';

type PasswordConfirmationProps = React.ComponentProps<typeof PasswordField> & { password: string };

export const PasswordConfirmation: React.FC<PasswordConfirmationProps> = ({ password, ...fieldProps }) => {
    const { t } = useTranslation();
    const valid = Object.values(getPasswordRequirements(password)).every(Boolean);

    return (
        <Collapse
            in={valid}
            timeout={400}
            aria-hidden={!valid}
            sx={{ '@media (prefers-reduced-motion: reduce)': { transitionDuration: '0ms !important' } }}
        >
            <div className="pt-vsmall">
                <PasswordField
                    appearance="web"
                    {...fieldProps}
                    fullWidth
                    name="passwordConfirm"
                    label={t('dialogs.signUp.passwordRequirements.confirmAgain')}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    disabled={!valid}
                />
            </div>
        </Collapse>
    );
};
